import {
  Dispatch,
  useState
} from 'react';
import {
  LicenseOrganizationController,
} from '../../../../api/license/license-organization.controller';
import {LicenseTemplateController} from '../../../../api/license/license-template.controller';
import {
  OrganizationController
} from '../../../../api/organization/organization.controller';
import {useAsyncEffect} from '../../../../hook/use-initial-load';
import {FeatureTemplate} from '../../../../model/license/feature-template.model';
import { LicenseDetails } from '../../../../model/license/license-details.model';
import {LicenseFeatureDetails} from '../../../../model/license/license-feature-details.model';
import {GrantLogEntry} from '../../../../model/license/grant-log-entry.model';
import {OrganizationData} from '../../../../model/organization/organization-data';

export namespace OrganizationDetailsPageHooks {
  export const useLicenseDetails = (groupId: string): [LicenseDetails | null, Dispatch<LicenseDetails>] => {
    const [licenseDetails, setLicenseDetails] = useState<LicenseDetails | null>(null);
    useAsyncEffect(async () => {
      setLicenseDetails(await fetchLicenseDetails(groupId))
    }, []);
    return [licenseDetails, setLicenseDetails];
  }

  export const fetchLicenseDetails = async (groupId: string) =>
    await LicenseOrganizationController.queryOrganizationLicenseDetails(groupId)

  export const useFeatureTemplates = (): [FeatureTemplate[], Dispatch<FeatureTemplate[]>] => {
    const [featureTemplates, setFeatureTemplates] = useState<FeatureTemplate[]>([]);
    useAsyncEffect(async () => {
      setFeatureTemplates(await fetchFeatureTemplates())
    }, []);
    return [featureTemplates, setFeatureTemplates];
  }

  const fetchFeatureTemplates = async (): Promise<FeatureTemplate[]> =>
    (await LicenseTemplateController.queryFeatureTemplates())

  export const useLicenseFeatureDetails = (groupId: string): [LicenseFeatureDetails[], Dispatch<LicenseFeatureDetails[]>] => {
    const [licenseFeatureDetails, setLicenseFeatureDetails] = useState<LicenseFeatureDetails[]>([]);
    useAsyncEffect(async () => {
      setLicenseFeatureDetails(await fetchLicenseFeatureDetails(groupId))
    }, []);
    return [licenseFeatureDetails, setLicenseFeatureDetails];
  }

  export const fetchLicenseFeatureDetails = async (groupId: string): Promise<LicenseFeatureDetails[]> =>
    (await LicenseOrganizationController.queryLicenseFeatureDetails(groupId))

  export const useOrganizationDetails = (groupId: string): [OrganizationData | null, Dispatch<OrganizationData>] => {
    const [organizationDetails, setOrganizationDetails] = useState<OrganizationData | null>(null);
    useAsyncEffect(async () => {
      setOrganizationDetails(await fetchOrganizationDetails(groupId))
    }, []);
    return [organizationDetails, setOrganizationDetails];
  }

  const fetchOrganizationDetails = async (groupId: string): Promise<OrganizationData> =>
    (await OrganizationController.fetchOrganization(groupId))

  export const useGrantLog = (groupId: string): [GrantLogEntry[], Dispatch<GrantLogEntry[]>] => {
    const [grantLog, setGrantLog] = useState<GrantLogEntry[]>([]);
    useAsyncEffect(async () => {
      setGrantLog(await fetchGrantLog(groupId))
    }, []);
    return [grantLog, setGrantLog];
  }

  export const fetchGrantLog = async (groupId: string): Promise<GrantLogEntry[]> =>
    (await LicenseOrganizationController.queryGrantLog(groupId))
}